import { ChatListItem, ChatListValue } from '../typings/chatList';

export const OPEN_CHAT_LIST_EDITOR = 'OPEN_CHAT_LIST_EDITOR';
export type OPEN_CHAT_LIST_EDITOR = typeof OPEN_CHAT_LIST_EDITOR;

export interface OpenChatListEditorAction {
    type: OPEN_CHAT_LIST_EDITOR;
    editorId: string;
    savedValue: ChatListValue;
}

export function openChatListEditor(
    editorId: string,
    savedValue: ChatListValue
): OpenChatListEditorAction {
    return {
        type: OPEN_CHAT_LIST_EDITOR,
        editorId,
        savedValue
    };
}

export const UPDATE_CHATS_CHAT_LIST_EDITOR = 'UPDATE_CHATS_CHAT_LIST_EDITOR';
export type UPDATE_CHATS_CHAT_LIST_EDITOR = typeof UPDATE_CHATS_CHAT_LIST_EDITOR;

export interface UpdateChatsChatListEditorAction {
    type: UPDATE_CHATS_CHAT_LIST_EDITOR;
    chats: Array<ChatListItem>;
}

export function updateChatsChatListEditor(
    chats: Array<ChatListItem>
): UpdateChatsChatListEditorAction {
    return {
        type: UPDATE_CHATS_CHAT_LIST_EDITOR,
        chats
    };
}

export const CLOSE_CHAT_LIST_EDITOR = 'CLOSE_CHAT_LIST_EDITOR';
export type CLOSE_CHAT_LIST_EDITOR = typeof CLOSE_CHAT_LIST_EDITOR;

export interface CloseChatListEditorAction {
    type: CLOSE_CHAT_LIST_EDITOR;
    editorId: string;
}

export function closeChatListEditor(
    editorId: string
): CloseChatListEditorAction {
    return {
        type: CLOSE_CHAT_LIST_EDITOR,
        editorId
    };
}

export const CHANGE_SEARCH_INPUT_CHAT_LIST_EDITOR =
    'CHANGE_SEARCH_INPUT_CHAT_LIST_EDITOR';
export type CHANGE_SEARCH_INPUT_CHAT_LIST_EDITOR = typeof CHANGE_SEARCH_INPUT_CHAT_LIST_EDITOR;

export interface ChangeSearchInputChatListEditorAction {
    type: CHANGE_SEARCH_INPUT_CHAT_LIST_EDITOR;
    editorId: string;
    searchInputText: string;
}

export function changeSearchInputChatListEditor(
    editorId: string,
    searchInputText: string
): ChangeSearchInputChatListEditorAction {
    return {
        type: CHANGE_SEARCH_INPUT_CHAT_LIST_EDITOR,
        editorId,
        searchInputText
    };
}

export const CHANGE_FILTERED_CHATS_CHAT_LIST_EDITOR =
    'CHANGE_FILTERED_CHATS_CHAT_LIST_EDITOR';
export type CHANGE_FILTERED_CHATS_CHAT_LIST_EDITOR = typeof CHANGE_FILTERED_CHATS_CHAT_LIST_EDITOR;

export interface ChangeFilteredChatsChatListEditorAction {
    type: CHANGE_FILTERED_CHATS_CHAT_LIST_EDITOR;
    editorId: string;
    filterValue: string;
}

export function changeFilteredChatsChatListEditor(
    editorId: string,
    filterValue: string
): ChangeFilteredChatsChatListEditorAction {
    return {
        type: CHANGE_FILTERED_CHATS_CHAT_LIST_EDITOR,
        editorId,
        filterValue
    };
}

export const SELECT_CHAT_LIST_EDITOR = 'SELECT_CHAT_LIST_EDITOR';
export type SELECT_CHAT_LIST_EDITOR = typeof SELECT_CHAT_LIST_EDITOR;

export interface SelectChatListEditorAction {
    type: SELECT_CHAT_LIST_EDITOR;
    editorId: string;
    selectedId: string;
}

export function selectChatListEditor(
    editorId: string,
    selectedId: string
): SelectChatListEditorAction {
    return {
        type: SELECT_CHAT_LIST_EDITOR,
        editorId,
        selectedId
    };
}

export const FETCH_CHATS_CHAT_LIST_EDITOR = 'FETCH_CHATS_CHAT_LIST_EDITOR';
export type FETCH_CHATS_CHAT_LIST_EDITOR = typeof FETCH_CHATS_CHAT_LIST_EDITOR;

export interface FetchChatsChatListEditorAction {
    type: FETCH_CHATS_CHAT_LIST_EDITOR;
}

export function fetchChatsChatListEditor(): FetchChatsChatListEditorAction {
    return {
        type: FETCH_CHATS_CHAT_LIST_EDITOR
    };
}

export const SHOW_CHATS_ERROR_CHAT_LIST_EDITOR =
    'SHOW_CHATS_ERROR_CHAT_LIST_EDITOR';
export type SHOW_CHATS_ERROR_CHAT_LIST_EDITOR = typeof SHOW_CHATS_ERROR_CHAT_LIST_EDITOR;

export interface ShowChatsErrorChatListEditorAction {
    type: SHOW_CHATS_ERROR_CHAT_LIST_EDITOR;
}

export function showChatsErrorChatListEditor(): ShowChatsErrorChatListEditorAction {
    return {
        type: SHOW_CHATS_ERROR_CHAT_LIST_EDITOR
    };
}

export type ChatListEditorAction =
    | OpenChatListEditorAction
    | UpdateChatsChatListEditorAction
    | CloseChatListEditorAction
    | ChangeSearchInputChatListEditorAction
    | ChangeFilteredChatsChatListEditorAction
    | FetchChatsChatListEditorAction
    | SelectChatListEditorAction
    | ShowChatsErrorChatListEditorAction;
